import script from "./Privacy.vue?vue&type=script&setup=true&lang=js"
export * from "./Privacy.vue?vue&type=script&setup=true&lang=js"

import "./Privacy.vue?vue&type=style&index=0&id=3546c3fa&lang=scss&scoped=true"

import exportComponent from "/tmp/tesla_data/tmp/apply_3091/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3546c3fa"]])

export default __exports__